import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { shareReplay } from 'rxjs/internal/operators';
import * as hmacsha1 from 'hmacsha1';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private menu;

  constructor(private http: HttpClient) {}

  getMenu(): Observable<any> {
    if (this.menu) {
      return this.menu;
    } else {
      const CLIENT_SECRET = 'PkkJXNRpO2l0r5u6u0PlCNme1KA8akGejMIjHI5Gkj8';
      const CLIENT_ID = 'c3sbrpbtkbs5gverurfkxpemc';

      const baseUrl = `/locations/auburn-66/menus/?client=${CLIENT_ID}`;
      const hash = hmacsha1(CLIENT_SECRET, baseUrl);
      const signature = encodeURIComponent(hash);
      const url = `https://publishing-api.singleplatform.com${baseUrl}&signature=${signature}`;

      this.menu = this.http.get(url).pipe(shareReplay(1));
      return this.menu;
    }
  }
}
